import { View } from "react-native";
import StyledText from "./ui/styled-text";
import AgentSelector from "../feature/header/agent-selector/agent-selector";
import { LucideIcon } from "lucide-react-native";

interface PageHeaderProps {
  title: string;
  headerIcon?: LucideIcon;
}

export default function PageHeader({
  title,
  headerIcon: Icon,
}: PageHeaderProps) {
  return (
    <View className="hidden bg-white sm:flex flex-row items-center justify-between h-16 border-b border-border pl-4 pr-2">
      <View className="flex flex-row items-center gap-2">
        {Icon && <Icon size={16} color="#1f2937" />}
        <StyledText className="text-lg font-semibold text-gray-800">
          {title}
        </StyledText>
      </View>
      <View className="flex flex-row items-center gap-2">
        <View className="max-w-96">
          <AgentSelector />
        </View>
      </View>
    </View>
  );
}
